import { Dispatch, SetStateAction, useCallback } from 'react';

import { User } from '@/types/userList';
import { UpdateError } from './useUploadCsv';

type Props = {
  currentOrganizationId: number;
  fetchUserList: (organizationId: number) => Promise<User[] | null>;
  setCsvFormatError: Dispatch<SetStateAction<string | null>>;
  setCsvUpdateErrors: Dispatch<SetStateAction<UpdateError[] | null>>;
  setIsPreview: Dispatch<SetStateAction<boolean>>;
  setSelectedUserId: Dispatch<SetStateAction<number | null>>;
  setUsers: Dispatch<SetStateAction<User[] | null>>;
};

export const useRefreshPage = ({
  currentOrganizationId,
  fetchUserList,
  setCsvFormatError,
  setCsvUpdateErrors,
  setIsPreview,
  setSelectedUserId,
  setUsers,
}: Props) => {
  const refreshPage = useCallback(async () => {
    setSelectedUserId(null);
    setCsvFormatError(null);
    setCsvUpdateErrors(null);
    setIsPreview(false);

    const users = await fetchUserList(currentOrganizationId);

    setUsers(users);
  }, [
    currentOrganizationId,
    fetchUserList,
    setCsvFormatError,
    setCsvUpdateErrors,
    setIsPreview,
    setSelectedUserId,
    setUsers,
  ]);

  return { refreshPage };
};
